import React from "react";
import { makeStyles } from "@material-ui/styles";

export default function SimpleTable(props) {
  const useStyles = makeStyles((theme) => ({
    table: {
      width: "100%",
      tableLayout: "fixed",
      borderCollapse: 'collapse',
    },
    thead: {
      color: theme.palette.secondary.main
    },
    td: {
      padding: 3,
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
    },
    tableRow: {
      "&:hover": {
        backgroundColor: '#eeeeee',
      },
      borderTop: '1px solid #D3D3D3',
      "&:last-child": {
        borderBottom: '1px solid #D3D3D3',
      },
      "&:nth-child(even)": {
        backgroundColor: '#f3f3f3',
        "&:hover": {
          backgroundColor: '#eeeeee',
        },
      }
    },
  }));

  const classes = useStyles(props);
  const { data, columns, showHeader, emptyMessage } = props;

  if ((!data || !data.length) && emptyMessage)  {
    return emptyMessage;
  }

  return (
    <table className={classes.table} >
      {showHeader &&
        <thead className={classes.thead}>
          <tr>
            {columns.map((col) => {
              return (
                <td className={classes.td} style={{ ...col["headerStyles"] }}>{col["header"]}</td>
              );
            })}
          </tr>
        </thead>
      }
      <tbody>
        {data.map((row) => {
          return (
            <tr className={classes.tableRow}>
              {columns.map((col) => {
                const value = col["value"] ? col["value"](row) : row[col["accessor"]];
                return (
                    <td className={classes.td} style={{ ...col["bodyStyles"] }}>{value}</td>
                );
              })}
            </tr>);
        })}
      </tbody>
    </table>
  );
}
